// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3316":"d5085b4b","8310":"446ed3ae"}[chunkId] + ".chunk.css";
};